import { endereco_empty } from "@/components/Form/Endereco/get_endereco_empty";
import { contatos_empty } from "@/components/Form/Contatos/get_contacts_empty";

export const pessoa_fisica_empty = () => ({
  nome: "",
  cpf: "",
  rg: "",
  data_nascimento: null,
  endereco: endereco_empty(),
  contatos: contatos_empty(),
});

export default pessoa_fisica_empty;
